import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { GoldBow } from './GoldBow';

/**
 * Section divider: a small centered gold bow with a thin camel hairline
 * running left and right of it. The bow drifts and rocks a couple of degrees in 3D
 * so the mark feels suspended rather than pasted on. Still under reduced motion.
 */
export function SectionDivider({
  tone = 'light'
}: {
  tone?: 'light' | 'warm';
}) {
  const reduce = useReducedMotion();
  return <div aria-hidden="true" className={`w-full ${tone === 'warm' ? 'bg-offwhite' : 'bg-white'}`} data-id="element-413" data-mp="2zf536j0eq08h">
      <div className="mx-auto flex w-full max-w-7xl items-center gap-5 px-4 py-8 sm:px-6 md:py-10" style={{
      perspective: 700
    }} data-id="element-414" data-mp="2ug1vsrwyfhxc">
        <motion.span className="h-px flex-1 origin-right bg-camel/45" initial={reduce ? undefined : {
        scaleX: 0
      }} whileInView={{
        scaleX: 1
      }} viewport={{
        once: true,
        amount: 0.6
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-415" data-mp="2qfrpfe592phy" />
        <motion.span className="shrink-0" style={{
        transformStyle: 'preserve-3d'
      }} animate={reduce ? undefined : {
        y: [0, -4, 0],
        rotateY: [-8, 8, -8]
      }} transition={{
        duration: 7,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-416" data-mp="3ap5gfmy7xh1o">
          <GoldBow className="h-6 w-8" data-id="element-417" data-mp="36ntvhuqahjzt" />
        </motion.span>
        <motion.span className="h-px flex-1 origin-left bg-camel/45" initial={reduce ? undefined : {
        scaleX: 0
      }} whileInView={{
        scaleX: 1
      }} viewport={{
        once: true,
        amount: 0.6
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-418" data-mp="36lzcilykw1yd" />
      </div>
    </div>;
}